module.exports = __webpack_public_path__ + "img/TSN_phone_02.ba37605c.png";